import React, { useEffect, useState } from "react";
import axios from "axios";
import moment from "moment";

export default function Contacts() {
  const [contacts, setContacts] = useState([]);
  useEffect(() => {
    const fetchMails = async () => {
      const { data } = await axios.get("/api/contacts/");
      setContacts(data);
    };
    fetchMails();
  }, []);
  return (
    <div className="ibox-content row mt-2 mx-1 px-0 h-100">
      <div className="file-manager col-3">
        <ul className="folder-list pl-3">
          <li className="my-4"><a className="btn btn-block btn-primary compose-mail text-white" href="/">Compose Mail</a></li>
          <li><a href="/"><i className="fa fa-inbox " />Inbox<span className="label label-warning float-right">16</span></a></li>
          <li><a href="/"><i className="fa fa-envelope-o" /> Send Mail</a></li>
          <li><a href="/"><i className="fa fa-file-text-o" /> Drafts<span className="label label-danger float-right">2</span></a></li>
          <li><a href="/"><i className="fa fa-trash-o" /> Trash</a></li>
        </ul>
      </div>
      <div className="col-9">
        <div className="mail-box-header">
          <form className="float-right mail-search">
            <div className="input-group">
              <input type="text" placeholder="Search email" className="form-control" />
              <span className="input-group-append"><button type="button" data-toggle="tooltip" title="Search" className="btn btn-primary"><i className="fa fa-search" /></button></span>
            </div>
          </form>
          <h3>Inbox (16)</h3>
          <div className="mail-tools">
            <button className="btn btn-white mx-1" data-toggle="tooltip" title="Refresh inbox">
              <i className="fa fa-refresh" />
            </button>
            <button className="btn btn-white mx-1" data-toggle="tooltip" title="Mark as read">
              <i className="fa fa-eye" />
            </button>
            <button className="btn btn-white mx-1" data-toggle="tooltip" title="Move to trash">
              <i className="fa fa-trash-o" />{" "}
            </button>
          </div>
        </div>
        <div className="mail-box h-75">
          <table className="table table-hover table-mail">
            <tbody>
              {contacts.map((mail, index) => (
                <tr className="unread" key={index} >
                  <td className="mail-ontact"><small>{mail.sender_name}</small></td>
                  <td className="mail-subject"><small>{mail.subject}</small></td>
                  <td className="text-right mail-date"><small>{moment(mail.timestamp).format('DD MMM hh:mm A')}</small></td>
                </tr>
              ))}
            </tbody>
          </table>
          <ul className="pagination sticky-bottom">
            <li className="paginate_button page-item previous disabled"><a href="/" className="page-link">Previous</a></li>
            <li className="paginate_button page-item active"><a href="/" className="page-link">1</a></li>
            <li className="paginate_button page-item "><a href="/" className="page-link">2</a></li>
            <li className="paginate_button page-item "><a href="/" className="page-link">3</a></li>
            <li className="paginate_button page-item next"><a href="/" className="page-link">Next</a></li>
          </ul>
        </div>
      </div>
    </div>
  );
}
